// extracted by mini-css-extract-plugin
export default {"title":"FormTableExpected_title__C97C2","titleDisabled":"FormTableExpected_titleDisabled__vjZVE","percentagePadding":"FormTableExpected_percentagePadding__vw0ZN"};